import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
// import { AngularFireAuth } from '@angular/fire/compat/auth'; // Remove direct import
import { Observable, of } from 'rxjs';
// import { map, take, tap } from 'rxjs/operators'; // Back to take(1)
import { map, first, catchError, tap } from 'rxjs/operators'; // Keep tap for logging if needed
import { AuthService } from '../services/auth.service'; // Import AuthService
// import firebase from 'firebase/compat/app'; // Namespace needed for User type hint below?
// Let's remove the type hint for now if it causes issues, default value type is inferred.

@Injectable({
    providedIn: 'root'
})
export class LoggedInGuard {

    // constructor(private afAuth: AngularFireAuth, private router: Router) { }
    constructor(private authService: AuthService, private router: Router) { } // Inject AuthService

    canActivate(): Observable<boolean | UrlTree> {
        // return this.afAuth.authState.pipe(
        return this.authService.authState.pipe(
            tap(user => console.log('LoggedInGuard: authState received:', user)), // Optional: for debugging
            map(user => {
                if (user) {
                    console.log('LoggedInGuard: User is authenticated.');
                    return true;
                } else {
                    console.log('LoggedInGuard: User is not authenticated. Redirecting to /login.');
                    return this.router.createUrlTree(['/login']);
                }
            }),
            first(), // Ensure the guard resolves after the first emission from map.
            catchError((error) => {
                // This would catch errors if authState itself errors before emitting.
                console.error('LoggedInGuard: Error in authState pipe:', error);
                console.log('LoggedInGuard: Redirecting to /login due to error.');
                return of(this.router.createUrlTree(['/login']));
            })
        );
    }
} 